// AUTOGENERATED by replayer/build.py — do not edit by hand.
// Sourced from SHORT_NAMES in replayer/build.py.

export const CONDITION_SHORT_NAMES: Record<string, string> = {
  "B02.01": "Sycophant",
  "B03.01": "Gullible",
  "B05.01": "Amnesia",
  "B05.02": "UserLoop",
  "B05.03": "AILoop",
  "B05.04": "Regress",
  "B05.05": "Frustrate",
  "B06.01": "Confab",
  "B07.01": "Rational",
  "B08.01": "FalseCoT",
  "C01.01": "Mutation",
  "C02.01": "SpecDrift",
  "C03.01": "DKEffect",
  "C04.01": "DebugFail",
  "C05.01": "SemLeak",
  "D01.02": "BitRot",
  "D02.01": "VibeDebt",
  "D03.01": "ValDrift",
  "G01.01": "RegCap",
  "G02.01": "Plagiar",
  "G03.01": "VoteCorr",
  "G04.01": "AutoImm",
  "G05.01": "Cancer",
  "G06.01": "RwdHack",
  "H01.01": "HarmAid",
  "H02.01": "AutoBias",
  "H03.01": "Deepfake",
  "H04.01": "SkillRot",
  "H05.01": "AcctSink",
  "H06.01": "RevCentr",
  M01: "BadData",
  "M02.01": "FitDrift",
  "M03.02": "MAD",
  "M04.01": "InfoPoll",
  "M05.01": "CtxPoll",
  "P01.01": "Parasite",
  "P02.01": "Mimicry",
  "P02.02": "TypoAttk",
  "P03.01": "Jailbreak",
  "P04.01": "Slopsquat",
  "P04.02": "Watering",
  "P06.01": "CrimeAid",
  "R01.02": "ConfBias",
  "R01.03": "Pareidol",
  "R01.04": "Distract",
  "R02.01": "ClassBlnd",
  "R02.02": "NewBlind",
  "T01.01": "ShadowAI",
  "T02.01": "BadPrompt",
  "T03.01": "Thrashing",
  "T04.01": "GreedTrap",
};
